"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React from "react";
import { cn } from "../cn";
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipArrow = TooltipPrimitive.Arrow;
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, portalled, ...props }, ref) => {
    const content = (_jsx(TooltipPrimitive.Content, { ref: ref, sideOffset: sideOffset, className: cn(
        /* add this if we decide to do exit animations: data-[state=closed]:animate-out */
        "fade-in-50 z-tooltip animate-in overflow-hidden rounded-md bg-zinc-700 px-3 py-1.5 text-white text-xs shadow-md ", "data-[side=bottom]:slide-in-from-top-1 data-[state=closed]:data-[side=bottom]:slide-out-to-top-1", "data-[side=left]:slide-in-from-right-1 data-[state=closed]:data-[side=left]:slide-out-to-right-1", "data-[side=right]:slide-in-from-left-1 data-[state=closed]:data-[side=right]:slide-out-to-left-1", "data-[side=top]:slide-in-from-bottom-1 data-[state=closed]:data-[side=top]:slide-out-to-bottom-1", className), ...props }));
    if (portalled)
        return _jsx(TooltipPrimitive.Portal, { children: content });
    return content;
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, TooltipArrow, };
